module.exports = __webpack_public_path__ + "img/logo.8773495f.jpg";